// Default subscription plans
export const DEFAULT_SUBSCRIPTION_PLANS = {
  'plan_1': {
    id: 'plan_1',
    name: 'Starter',
    description: 'Perfect for testing and light content updates',
    price: 9.99,
    features: [
      'AI Generation',
      'Price Tools',
      'Up to 14 product edits/month',
      '100 credits per month',
      'Edit up to 5 products at once'
    ],
    enabled: true,
    sortOrder: 1,
    maxProductSelection: 14,
    monthlyCredits: 100,
    planLevel: 1
  },
  'plan_2': {
    id: 'plan_2',
    name: 'Standard',
    description: 'Ideal for smaller shops and regular listings',
    price: 19.99,
    features: [
      'AI Generation',
      'Price Tools',
      'Inventory Tools',
      'Up to 35 product edits/month',
      '250 credits per month',
      'Edit up to 15 products at once'
    ],
    enabled: true,
    sortOrder: 2,
    maxProductSelection: 35,
    monthlyCredits: 250,
    planLevel: 2
  },
  'plan_3': {
    id: 'plan_3',
    name: 'Premium',
    description: 'Great for growing stores and weekly batches',
    price: 49.99,
    features: [
      'AI Generation',
      'Price Tools',
      'Inventory Tools',
      'Product Tools',
      'Up to 100 product edits/month',
      '700 credits per month',
      'Edit up to 25 products at once'
    ],
    enabled: true,
    sortOrder: 3,
    maxProductSelection: 100,
    monthlyCredits: 700,
    planLevel: 3,
    mostPopular: true
  },
  'plan_4': {
    id: 'plan_4',
    name: 'Enterprise',
    description: 'Designed for active catalogs with frequent updates',
    price: 99.99,
    features: [
      'AI Generation',
      'Price Tools',
      'Inventory Tools',
      'Product Tools',
      'Priority Support',
      'Up to 230 product edits/month',
      '1600 credits per month',
      'Edit up to 50 products at once'
    ],
    enabled: true,
    sortOrder: 4,
    maxProductSelection: 230,
    monthlyCredits: 1600,
    planLevel: 4
  },
  'plan_5': {
    id: 'plan_5',
    name: 'Ultimate',
    description: 'Built for high-volume sellers and automation',
    price: 199.99,
    features: [
      'AI Generation',
      'Price Tools',
      'Inventory Tools',
      'Product Tools',
      'Dedicated Support',
      'Up to 500 product edits/month',
      '3500 credits per month',
      'Edit up to 100 products at once'
    ],
    enabled: true,
    sortOrder: 5,
    maxProductSelection: 500,
    monthlyCredits: 3500,
    planLevel: 5
  }
};

// Default flex credit packages
export const DEFAULT_FLEX_CREDIT_PACKAGES = {
  'package_1': {
    id: 'package_1',
    name: 'Small',
    description: 'For occasional use',
    price: 9.99,
    credits: 10,
    enabled: true,
    sortOrder: 1
  },
  'package_2': {
    id: 'package_2',
    name: 'Medium',
    description: 'Most popular choice',
    price: 19.99,
    credits: 25,
    enabled: true,
    sortOrder: 2
  },
  'package_3': {
    id: 'package_3',
    name: 'Large',
    description: 'Best value',
    price: 39.99,
    credits: 60,
    enabled: true,
    sortOrder: 3
  }
};

// Default tool descriptions
export const DEFAULT_TOOL_DESCRIPTIONS = {
  priceTools: `**Bulk Price Updates** - Modify prices across multiple products at once using percentage or fixed amount adjustments\n\n**Price Change Types** - Increase, decrease, or set specific prices with flexible options\n\n**Compare-at-Price Management** - Easily set and adjust compare-at prices to show savings\n\n**Price Rounding** - Automatically round prices to maintain consistent pricing patterns\n\n**Save & Load Settings** - Save pricing strategies for future use`,
  inventoryTools: `**Bulk Inventory Updates** - Update inventory quantities across multiple products simultaneously\n\n**Selective Updates** - Option to ignore products with zero inventory\n\n**Save & Load Settings** - Store inventory management preferences`,
  productTools: `**Handle Management** - Generate custom handles with prefixes/suffixes or empty handles for Shopify auto-generation\n\n**Vendor Management** - Update vendor information across multiple products\n\n**SKU Generator** - Create SKUs for all variants using customizable format with product title, variant options, and prefixes/suffixes\n\n**Save & Load Settings** - Store product management preferences for future use`
};
